import { render, staticRenderFns } from "./EditorList.vue?vue&type=template&id=20e2838e"
import script from "./EditorList.vue?vue&type=script&lang=ts"
export * from "./EditorList.vue?vue&type=script&lang=ts"
import style0 from "./EditorList.vue?vue&type=style&index=0&id=20e2838e&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports